import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

function Service({ item, index }) {
  const [serv, servInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1+index*0.1,
        ease: "easeInOut",
      },
    },
  };
  return (
    <motion.div
      className="service"
      ref={serv}
      initial="hidden"
      animate={servInView ? "visible" : "hidden"}
      variants={animationVariants}
    >
      <div className="service-title">{item.title}</div>
      <div className="service-description">{item.description}</div>
    </motion.div>
  );
}

export default Service;
